import { useEffect, useState } from "react"



export default function PhpTest() {
  const [message, setMessage] = useState("Uninitialised");

  useEffect(() => {
    fetch('/api/api.php')
      .then(response => response.json())
      .then(data => setMessage(data.message))
      .catch(error => console.error('Error:', error));
  }, []);

  return (
    <div style={{margin: '20px'}}>
      <h1>Response</h1>
      <p>{message}</p>
    </div>
  );
}